import '../../modules/mode-components';

import * as angular from 'angular';
import { debounce } from 'lodash';

class AceTextareaController {
  static $inject = ['ace', '$timeout', '$element', '$scope'];

  private textareaModel: any;
  private editor: any;
  private mode: string;
  private maxLines: number;

  constructor(
    private ace,
    private $timeout,
    private $element,
    private $scope
  ) {}

  $onInit() {
    const editElem = this.$element.find('.ace-textarea-editor');
    this.editor = this.ace.edit(editElem[0]);
    // turn off web workers
    this.editor.getSession().setUseWorker(false);
    // remove deprecation warning
    this.editor.$blockScrolling = Infinity;
    this.editor.renderer.$fontMetrics.setPolling(false);

    this.editor.getSession().setMode('ace/mode/' + (this.mode || 'javascript'));
    this.editor.setAutoScrollEditorIntoView(true);
    this.editor.setHighlightActiveLine(true);
    this.editor.setShowPrintMargin(false);
    this.editor.container.style.lineHeight = '18px';
    this.editor.setOptions({
      fontSize: 12,
      maxLines: this.maxLines || 25,
      showGutter: true,
      enableBasicAutocompletion: false,
      behavioursEnabled: true,
    });
    this.editor.getSession().setTabSize(2);

    // clean up common commands
    this.editor.commands.removeCommand('find');
    this.editor.commands.removeCommand('gotoline');

    this.editor.commands.bindKey('ctrl-space', null);
    this.editor.commands.bindKey('ctrl-shift-space', null);
    this.editor.commands.bindKey('alt-space', null);

    this.editor.commands.addCommands([
      {
        name: 'nouppercase',
        bindKey: { win: 'Ctrl-U', mac: 'Ctrl-U' },
        exec: function () {
          return false;
        },
      },
      {
        name: 'nofindnext',
        bindKey: { win: 'Ctrl-K', mac: 'Ctrl-K' },
        exec: function () {
          return false;
        },
      },
      {
        name: 'bluronescape',
        bindKey: { win: 'esc', mac: 'esc' },
        exec: function (editorElem) {
          editorElem.blur();
        },
      },
    ]);

    // register change handlers
    const onChange = () => (e) => {
      const newValue = this.editor.session.getValue();
      // HACK make sure to only trigger the apply outside of the
      // digest loop 'cause ACE is actually using this callback
      // for any text transformation !
      if (!this.$scope.$$phase && !this.$scope.$root.$$phase) {
        this.$scope.$evalAsync(() => {
          this.textareaModel = newValue;
        });
      }
    };

    this.editor.on(
      'change',
      debounce(() => {
        this.editor.renderer.$fontMetrics.checkForSizeChanges();
      }, 200)
    );

    this.$scope.$watch('ctrl.textareaModel', (newModel, oldModel) => {
      if (this.editor.session.getValue() !== newModel) {
        this.editor.getSession().setValue(newModel);
      }
    });

    this.editor.getSession().on('change', onChange());
  }

  $onDestroy() {
    this.editor.destroy();
  }
}

const AceTextareaComponent: angular.IComponentOptions = {
  bindings: {
    textareaModel: '=',
    mode: '@?',
    maxLines: '@?',
  },
  template: `
<div class="ace-textarea-editor" style="height:300px; width:100%;"></div>
`,
  controller: AceTextareaController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('aceTextarea', AceTextareaComponent);
